import { defineMessages, makeMessages } from "features/localisation";

const messages = makeMessages({
  heading: {
    id: "offline.offlineScreen.heading",
    defaultMessage: "Check your connection"
  },
  description: {
    id: "offline.offlineScreen.description",
    defaultMessage: "You need to be online to use Seneca"
  }
});

export { messages };
export default defineMessages(messages);
